export const fileDownloadHandler = (data, filename, type) => {
  if (!type) {
    throw new Error('useDownloadHandler: type is required')
  }

  if (!filename) {
    throw new Error('useDownloadHandler: filename is required')
  }

  if (data?.length === 0) return

  const blob = new Blob([data], { type })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.setAttribute('href', url)
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
